import * as types from './mutationTypes';

function replaceLMH(floor, lang) {
  let formattedFloor = floor;
  if (lang === 'en') {
    formattedFloor = formattedFloor.replace('**LOW**', 'Low Floor')
      .replace('**MID_LOW**', 'Mid-Low Floor')
      .replace('**MID**', 'Mid Floor')
      .replace('**HIGH_MID**', 'Mid-High Floor')
      .replace('**HIGH**', 'High Floor')
      .replace('**EXTR_HIGH**', 'Ex.High Floor');
  } else {
    formattedFloor = formattedFloor.replace('**LOW**', '低層')
      .replace('**MID_LOW**', '中低層')
      .replace('**MID**', '中層')
      .replace('**HIGH_MID**', '中高層')
      .replace('**HIGH**', '高層')
      .replace('**EXTR_HIGH**', '極高層');
  }
  return formattedFloor;
}

function formatTx(state, transactions, ics = null) {
  return transactions.map((tx) => {
    const name = {};
    const floor = {};
    const flat = {};
    const area = {};
    const icsType = ics || state.filters.icsType;
    const keyword = {};

    name.zh = tx.chi_name;
    name.en = tx.eng_name ? tx.eng_name : tx.chi_name;
    area.value = parseInt(tx.area, 10);

    const sbu = icsType === 'ics' ? tx.ics_type : icsType;

    if (sbu === 's') {
      floor.zh = tx.floor_zh ? tx.floor_zh : '';
      floor.en = tx.floor_en ? tx.floor_en : '';

      flat.zh = tx.flat;
      flat.en = tx.flat;

      name.zh = `${tx.dist_name_zh} ${name.zh}${tx.streetno}${tx.streetno ? '號' : ''} ${floor.zh} ${flat.zh}`;
      name.en = `${flat.en}${flat.en ? ', ' : ''} 
                ${floor.en}${floor.en ? ', ' : ''} 
                ${tx.streetno} ${name.en}${tx.dist_name_en ? ', ' : ''} ${tx.dist_name_en}`;

      area.zh = [];
      area.en = [];

      for (let i = 1; i <= 4; i += 1) {
        if (parseInt(tx[`area${i}`], 10) > 0 && tx[`area_desc${i}`]) {
          const ad = tx[`area_desc${i}`];
          const av = parseInt(tx[`area${i}`], 10);
          const ao = {
            desc: ad,
            value: av,
          };
          area.zh.push(ao);
          area.en.push(ao);
        }
      }

      keyword.searchText = `{"suggestionWord":"${tx.chi_name}","type":"addr","value":"${tx.street_id}","ics":"${sbu}"}`;
    } else {
      switch (typeof tx.floor) {
        case 'number':
          floor.zh = tx.floor ? `${tx.floor}樓` : '';
          floor.en = tx.floor ? `${tx.floor}/F` : '';
          break;
        case 'string':
          floor.zh = tx.floor ? replaceLMH(tx.floor, 'zh') : '';
          floor.en = tx.floor ? replaceLMH(tx.floor, 'en') : '';
          break;
        default:
          floor.zh = tx.floor ? `${tx.floor}樓` : '';
          floor.en = tx.floor ? `${tx.floor}/F` : '';
          break;
      }

      if (tx.flat === 'WF') {
        flat.zh = '全層';
        flat.en = 'Whole Floor';
      } else {
        flat.zh = `${tx.flat}${tx.flat ? '室' : ''}`;
        flat.en = `${tx.flat ? 'Unit ' : ''} ${tx.flat}`;
      }

      name.zh = `${tx.dist_name_zh} ${name.zh} ${floor.zh} ${flat.zh}`;
      name.en = `${tx.dist_name_en} ${name.en} ${floor.en} ${flat.en}`;

      keyword.searchText = `{"suggestionWord":"${tx.chi_name}","type":"building","value":"${tx.pis_bldg_id}","ics":"${icsType}"}`;
    }

    return {
      ...tx,
      icsType,
      name,
      floor,
      flat,
      area,
      keyword,
    };
  });
}

export default {
  [types.START_FETCH_TRANSACTIONS](state, { filters, fetchId }) {
    if (filters) {
      state.filters = {
        txType: [],
        districts: [],
        txSource: [],
        icsType: '',
        ...filters,
      };
    }
    state.fetchId = fetchId;
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.items = [];
  },

  [types.SET_FETCHED_TRANSACTIONS](state, { transactions, fetchId }) {
    if (fetchId === state.fetchId) {
      let sbu = 'ics';
      if (state.filters.icsType) {
        sbu = state.filters.icsType;
      }
      state.items = formatTx(state, transactions.transactions, sbu);

      state.fetchId = null;
      state.isFetching = false;
      state.isFetched = true;
      state.fetchError = null;
      state.totalCount = transactions.count;

      state.fetchCount = 1;
    }
  },

  [types.SET_FETCHED_DEFAULT_TRANSACTIONS](state, transactions) {
    state.isFetching = false;
    state.isFetched = true;
    state.fetchError = null;

    state.defaultItems = {
      i: formatTx(state, transactions.i, 'i'),
      c: formatTx(state, transactions.c, 'c'),
      s: formatTx(state, transactions.s, 's'),
    };
  },

  [types.FETCH_TRANSACTIONS_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.fetchError = error;
  },

  [types.START_FETCH_MORE_TRANSACTIONS](state) {
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
  },

  [types.APPEND_FETCHED_TRANSACTIONS](state, { transactions }) {
    state.isFetching = false;
    state.isFetched = true;

    let sbu = 'ics';
    if (state.filters.icsType) {
      sbu = state.filters.icsType;
    }
    state.items = state.items.concat(formatTx(state, transactions, sbu));
    state.fetchCount += 1;
  },

  [types.SET_FILTER](state, filter) {
    let filters = { ...state.filters, ...filter };
    if (filters.txType.length > 0 && !filters.txType.includes('S')) {
      // Remove sell related filters
      const {
        sellMin,
        sellMax,
        ftSellMin,
        ftSellMax,
        ...newFilters
      } = filters;
      filters = newFilters;
    }
    if (filters.txType.length > 0 && !filters.txType.includes('L')) {
      // Remove lease related filters
      const {
        rentMin,
        rentMax,
        ftRentMin,
        ftRentMax,
        ...newFilters
      } = filters;
      filters = newFilters;
    }
    state.filters = filters;
  },

  [types.UNSET_FILTER](state, filterKey) {
    const filters = {
      ...state.filters,
    };
    delete filters[filterKey];
    state.filters = filters;
  },

  [types.CHANGE_SORTING](state, { field, direction }) {
    state.sorting = {
      field,
      direction,
    };
  },

  [types.RESET_FETCH_COUNT](state) {
    state.fetchCount = 0;
  },

  [types.CLEAR_TRANSACTION_LIST](state) {
    state.items = [];
  },
};
